import { createAction } from "@logicsoftware/redux-toolkit";
import { BasePortfolio } from "~/normalizr/PortfoliosSchema";
import { createEntitiesSlice } from "../Entities";
import { portfolioSchema } from "./schema";

type LoadPayload = { forceReload: boolean };
export const loadPortfolios = createAction(
    "PORTFOLIOS/LOAD_PORTFOLIOS",
    (payload: LoadPayload = { forceReload: false }) => ({ payload })
);

export type AddPortfolioPayload = {
    name: string;
    parentId?: number;
    copyCustomFields?: boolean;
    callback?: (id: number) => void;
};

export const addPortfolio = createAction<AddPortfolioPayload>("PORTFOLIOS/ADD_PORTFOLIO");
export const { reducer: portfoliosReducer, updateEntities: updatePortfolios } = createEntitiesSlice<BasePortfolio>(
    portfolioSchema,
    { initState: null }
);
